import { Component, AfterViewInit, Inject, ViewEncapsulation } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { ApiService } from '../../services/api.service';

import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { UntypedFormControl, Validators } from '@angular/forms';

import { HttpErrorResponse } from '@angular/common/http';

import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'sd-playlist-dialog',
    templateUrl: './playlist-dialog.component.html',
    styleUrls: ['./playlist-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class PlaylistDialogComponent implements AfterViewInit {

    active = 'add';

    processing: Boolean = false;
    playlistsLoaded: Boolean = false;
    playlists = [];
    songSlugs = [];
    formSubmit:Boolean=false;
    createPlaylistForm: UntypedFormGroup;
    createPlaylistError: Boolean = false;
    createPlaylistErrorMsg: String = '';

    addToPlaylistForm: UntypedFormGroup;
    addToPlaylistError: Boolean = false;
    addToPlaylistErrorMsg: String = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<PlaylistDialogComponent>,
        public global: GlobalService,
        private api: ApiService,
        private toastrService: ToastrService,
        private user: UserService
    ) {
        // console.log(this.data.tracks);
        this.data.tracks.forEach(song => {
            this.songSlugs.push(song.slug);
        });

        this.showPlaylists();

        this.createPlaylistForm = new UntypedFormGroup({
            name: new UntypedFormControl('', [
                Validators.required,
                this.validSongTitle.bind(this)
            ]),
            privacy: new UntypedFormControl(true, [
                Validators.required
            ])
        });

        this.addToPlaylistForm = new UntypedFormGroup({
            playlist: new UntypedFormControl('', [
                Validators.required
            ])
        });
    }

    get name() { return this.createPlaylistForm.get('name'); }
    get playlist() { return this.addToPlaylistForm.get('playlist'); }

    ngAfterViewInit() {
    }

    onCreatePlaylistFormSubmit(formDirective) {
        this.formSubmit=true;
        if (this.createPlaylistForm.valid) {
            console.log(this.createPlaylistForm.value);
            // console.log(this.songSlugs);

            this.createPlaylist(this.createPlaylistForm.value.name, this.createPlaylistForm.value.privacy, this.songSlugs, formDirective);
        }
    }

    onAddToPlaylistFormSubmit(formDirective) {
        if (this.addToPlaylistForm.valid) {
            // console.log(this.addToPlaylistForm.value);
            // console.log(this.songSlugs);

            this.addToPlaylist(this.songSlugs, this.addToPlaylistForm.value.playlist);
        }
    }

    showPlaylists() {
        this.api.getProfilePlaylists(this.user.slug, 0, 50, true).subscribe(res => {
            this.playlistsLoaded = true;
            // console.log(res);

            if (res.success) {
                res.playlists.forEach(playlist => {
                    this.playlists.push({
                        'name': playlist.title,
                        'is_public': playlist.is_public,
                        'slug': playlist.slug_playlist,
                        'tracks': playlist.track,
                        'cover_pic':playlist.cover_pic
                    });
                });
// console.log(this.playlists)
                if (this.playlists.length == 0) {
                    this.active = 'create';
                }
            }
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!');
                }
            });
    }

    createPlaylist(playlist_name, privacy, song_slug, formDirective) {
        this.processing = true;

        this.api.createPlaylist(playlist_name, privacy, song_slug).subscribe(res => {
            // console.log(res);

            this.processing = false;
            if (res.success) {
                this.closeDialog();
                this.toastrService.success('Added to playlist!');
            } else {
                this.createPlaylistError = true;
                this.createPlaylistErrorMsg = res.error;
            }
        },
            (err: HttpErrorResponse) => {
                this.processing = false;
                this.createPlaylistError = true;
                if (err.error instanceof Error) {
                    this.createPlaylistErrorMsg = 'Client-side error occured!';
                    // console.log('Client-side error occured!');
                } else {
                    this.createPlaylistErrorMsg = 'Server-side error occured!';
                    // console.log('Server-side error occured!');
                }
            });
    }

    addToPlaylist(song_slug, playlist_slug) {
        this.processing = true;

        this.api.addToPlaylist(song_slug, playlist_slug).subscribe(res => {
            // console.log(res);

            this.processing = false;
            if (res.success) {
                this.closeDialog();
                this.toastrService.success('Added to playlist!');
            } else {
                this.addToPlaylistError = true;
                this.addToPlaylistErrorMsg = res.error;
            }
        },
            (err: HttpErrorResponse) => {
                this.processing = false;
                this.addToPlaylistError = true;
                if (err.error instanceof Error) {
                    this.addToPlaylistErrorMsg = 'Client-side error occured!';
                    // console.log('Client-side error occured!');
                } else {
                    this.addToPlaylistErrorMsg = 'Server-side error occured!';
                    // console.log('Server-side error occured!');
                }
            });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    validSongTitle(control: AbstractControl): { [key: string]: boolean } | null {
        let value;
        if (control.value != null) {
            value = control.value.trim();
        } else {
            value = '';
        }

        if (value == '') {
            return { 'validSongTitle': true };
        } else if (!this.global.trackTitleRegex.test(control.value)) {
            return { 'validSongTitle': true };
        }
        return null;
    }
}
